<template>
  <modal name="no-customer-yet-modal" @before-open="beforeOpen" :draggable="true" transition="pop-out"
         :width="800"
         :height="600">
    <h4 class="text-center panel-heading"><strong>{{$t("no_customer_yet")}}</strong></h4>
    <div class="row">
      <div class="col-sm-10 col-sm-offset-1">
        <div class="text-center">
          <strong><label>{{$t("no_customer_explanation")}}</label></strong>
        </div>
      </div>
    </div>
    <form @submit.prevent="becomeCustomerAndOrder()" v-if="showForm">
      <div class="row">
        <div class="col-sm-10 col-sm-offset-1">
          <div class="text-center">
            <p>{{$t("need_following_information")}}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-6 mb-20">
            <label>{{$t("company_name")}}*</label>
            <input type="text"
                   required
                   class="form-control"
                   v-model="customer.companyName">
          </div>
          <div class="col-sm-6 mb-20">
            <label>{{$t("kvk")}}*</label>
            <input type="text"
                   class="form-control"
                   required
                   v-model="customer.kvk">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-6 mb-20">
            <label>{{$t("name")}}*</label>
            <input type="text"
                   class="form-control"
                   required
                   v-model="customer.name">
          </div>
          <div class="col-sm-6 mb-20">
            <label>{{$t("address")}}*</label>
            <input type="text"
                   class="form-control"
                   required
                   v-model="customer.address">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-6 mb-20">
            <label>{{$t("zipCode")}}*</label>
            <input type="text"
                   class="form-control"
                   required
                   v-model="customer.zipCode">
          </div>
          <div class="col-sm-6 mb-20">
            <label>{{$t("city")}}*</label>
            <input type="text"
                   class="form-control"
                   required
                   v-model="customer.city">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-6 mb-20">
            <label>{{$t("email")}}*</label>
            <input type="email"
                   class="form-control"
                   required
                   v-model="customer.email">
          </div>
          <div class="col-sm-6 mb-20">
            <label>{{$t("phone_number")}}*</label>
            <input type="text"
                   class="form-control"
                   required
                   v-model="customer.phoneNumber">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-6 mb-20">
            <label>{{$t("country")}}*</label>
            <input type="text"
                   class="form-control"
                   required
                   v-model="customer.country">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="col-sm-6">
            <button type="submit" name="becomeCustomer" class="btn btn-success">{{$t("become_customer_and_order")}}</button>
          </div>
        </div>
      </div>
    </form>
  </modal>
</template>
<script>
  import { mapGetters } from 'vuex'
  import * as types from '../../store/mutation-types'

  export default {
    name: 'NoCustomerYet',
    data() {
      return {
        customer: {
          companyName: '',
          address: '',
          zipCode: '',
          city: '',
          kvk: '',
          phoneNumber: '',
          email: '',
          country: '',
          name: ''
        },
        showForm: ''
      }
    },
    methods: {
      getLocale() {
        return this.$i18n.locale
      },
      beforeOpen(event) {
        if (event.params) {
          this.products = event.params.products
          this.newOrder = event.params.order
        }
        this.showForm = event.params && event.params.products && event.params.order
      },
      becomeCustomerAndOrder() {
        this.$store.commit(types.SET_CUSTOMER_TO_CREATE, this.customer)
        this.$store.dispatch('createCustomer').then(() => {
          if (this.createdCustomer.id) {
            this.newOrder.customerId = this.createdCustomer.id
            this.$store.commit(types.SET_ORDER_TO_CREATE, { order: this.newOrder, products: this.products })
            this.$store.dispatch('createOrderForTemporaryCustomer').then(() => {
              if (this.order) {
                this.$store.dispatch('sendOrderConfirmationMail', this.order.id).then(() => {
                  if (this.isOrderMailSent) {
                    this.$store.commit(types.SET_PRODUCTS_IN_SHOPPING_CART, [])
                    this.customer.companyName = ''
                    this.customer.address = ''
                    this.customer.zipCode = ''
                    this.customer.city = ''
                    this.customer.kvk = ''
                    this.customer.phoneNumber = ''
                    this.customer.email = ''
                    this.customer.country = ''
                    this.customer.name = ''
                    localStorage.setItem('shoppingCart', [])
                    this.$notify({ group: 'success', type: 'success', title: 'Succes', text: 'Een bevestigingsmail is verzonden naar ' + this.createdCustomer.email + '!' })
                    this.$modal.hide('no-customer-yet-modal')
                    this.$router.push('/')
                  }
                })
              }
            })
          } else {
            this.$notify({ group: 'danger', type: 'error', title: 'Error', text: 'Er is iets fout gegaan bij het aanmaken van een nieuw account!' })
          }
        })
      }
    },
    computed: {
      ...mapGetters({
        createdCustomer: 'createdCustomer',
        order: 'order',
        isOrderMailSent: 'isOrderMailSent'
      })
    }
  }
</script>

<style scoped>

  .mb-20 {
    margin-bottom: 20px;
  }
</style>
